import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { IDropdownSettings, NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { DateTime } from "luxon";

import { EntityBase } from "../../entity/EntityBase";
import { Utility } from "../../entity/Utility";
import { SellOffer } from "../../entity/SellOffer";
import { SellerContract } from "../../entity/SellerContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { RateClass } from "../../entity/RateClass";
import { LoadZone } from "../../entity/LoadZone";
import { MatDatepickerInput, MatDatepicker } from "@angular/material/datepicker";
import { NgxMaskDirective } from "ngx-mask";

@Component({
    selector: "kilowant-seller-sell-offer-add-update-dialog",
    templateUrl: "../../../html/incs/seller-sell-offer-add-update-dialog.html",
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, NgMultiSelectDropDownModule, MatDatepickerInput, ReactiveFormsModule, MatDatepicker, NgxMaskDirective]
})
export class SellerSellOfferAddUpdateDialog extends AbstractSellerComponent {
    dropdownSettings: IDropdownSettings = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 1,
        allowSearchFilter: false,
        closeDropDownOnSelection: false
    };
    sellOffer: SellOffer = new SellOffer();

    globalStart: DateTime;
    globalEnd: DateTime;

    startDate = new UntypedFormControl();
    endDate = new UntypedFormControl();
    validDate = new UntypedFormControl();
    desiredTerm: string | null = null;
    utilities: Utility[] = null!;
    rateClasses: RateClass[] = [];
    loadZones: LoadZone[] = [];
    sellerContracts: SellerContract[] = [];

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog,
        public dialogRef: MatDialogRef<any>,
        private datepipe: DatePipe
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        super.ngOnInit();
    }

    pageStart(): void {
        this.globalStart = this.currentDate.startOf("month").plus({ months: 1 }).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        this.globalEnd = this.currentDate.plus({ years: 5 });
        if (this.sellOffer == null) {
            var d = this.currentDate.startOf("month").plus({ months: 1 });
            this.startDate = new UntypedFormControl();
            this.endDate = new UntypedFormControl();
            let ctrlValue = d;
            ctrlValue = ctrlValue.set({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 });
            this.startDate.setValue(ctrlValue);
            this.setDefaultDuration(this.startDate.value);
        }
        this.generalService.getSellerContracts()
            .then(cs => {
                if (cs != null) {
                    this.sellerContracts = cs;
                    this.cdr.detectChanges();
                }
            });

        this.utilities = this.user.utilities;
        this.reloadSelects();
    }

    public setSellOffer(sellOffer: SellOffer) {
        this.sellOffer = sellOffer;
        this.startDate.setValue(DateTime.fromJSDate(this.sellOffer.termFrom));
        this.validDate.setValue(DateTime.fromJSDate(this.sellOffer.validDate));
        this.endDate.setValue(DateTime.fromJSDate(this.sellOffer.termFrom).plus({ months: this.sellOffer.termPeriod }));
        this.setDesiredTerm();
    }

    onItemSelect(item: any, sellOffer: SellOffer, ifAdd: boolean): void {
        this.addRemoveRateClass(new RateClass(item.id), sellOffer, ifAdd);
    }

    addRemoveRateClass(rateClass: RateClass, sellOffer: SellOffer, ifAdd: boolean): void {
        if (ifAdd) {
            if (sellOffer.rateClasses == null) {
                sellOffer.rateClasses = [];
            }
            sellOffer.rateClasses.push(rateClass);
        } else {
            EntityBase.removeValueFromList(sellOffer.rateClasses, rateClass.id);
        }
    }

    sendForm(): void {
        this.clearErrors();
        var errorExists = false;
        if (this.sellOffer.utility == null) {
            this.addError("utilityId");
        }
        if (this.sellOffer.rateClasses == null || this.sellOffer.rateClasses.length == 0) {
            this.addError("rateClassId");
        }
        if (this.sellOffer.loadZone == null) {
            this.addError("loadZoneId");
        }
        if (this.sellOffer.price == null || this.sellOffer.price == 0) {
            this.addError("price");
        }
        if (this.sellOffer.termPeriod == null) {
            this.addError("termPeriod");
        }
        if (this.validDate == null || this.validDate.value == null) {
            this.addError("validDate");
        }
        if (this.startDate == null || this.startDate.value == null) {
            this.addError("startDate");
        }
        if (this.sellOffer.sellerContract == null) {
            this.addError("sellerContract");
        }
        this.sellOffer.termFrom = this.startDate.value;
        this.sellOffer.validDate = this.validDate.value;
        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above.");
            return;
        }
        if (this.endDate.value <= this.startDate.value) {
            this.setErrorText("Your service ending date is earlier than service starting date.");
            return;
        }
        if (this.sellOffer.id > 0) {
            this.generalService.updateSellOffer(this.sellOffer)
                .subscribe((res: any) => {
                    this.dialogRef.close(null!);
                },
                    err => {
                        if (err.status == 400) {
                            this.setErrorText(err.error);
                        }
                    });
        } else {
            this.generalService.addSellOffer(this.sellOffer)
                .subscribe((res: any) => {
                    this.dialogRef.close(null!);
                },
                    err => {
                        if (err.status == 400) {
                            this.setErrorText(err.error);
                        }
                    });
        }
    }

    public reloadSelects(): void {
        if (this.sellOffer.fuelType != null) {
            this.utilities = this.user.utilities;
            if (this.sellOffer.utility != null && !EntityBase.includes(this.utilities, this.sellOffer.utility)) {
                this.utilities.push(this.sellOffer.utility);
            }
        }
        if (this.sellOffer.utility != null) {
            this.generalService.getRateClasses(this.sellOffer.utility).then(r => this.rateClasses = r);
            this.generalService.getLoadZones(this.sellOffer.utility).then(l => this.loadZones = l);
        }
    }

    startDateChanged(val: any): void {
        if (this.validDate == null || this.validDate.value == null) {
            this.validDate.setValue(val.value.minus({ days: 1 }));
        }
    }

    inactiveDatesFilter(d: DateTime | null): boolean {
        if (d == null || this.globalStart == null || this.globalEnd == null) {
            return false;
        }
        if (d.day != 1) {
            return false;
        }
        var compareDate = this.applySitesTimeZone(d);
        return (compareDate >= this.globalStart) && (compareDate <= this.globalEnd);
    }

    inactiveDatesEndFilter(d: DateTime | null): boolean {
        if (d == null) {
            return false;
        }
        if (this.startDate != null && this.startDate.value != null) {
            if (d < this.startDate.value) {
                return false;
            }
        }
        return this.inactiveDatesFilter(d);
    }

    inactiveDatesValidFilter(d: DateTime | null): boolean {
        if (d == null || this.startDate == null || this.startDate.value == null) {
            return false;
        }
        var compareDate = this.applySitesTimeZone(d);
        return (compareDate >= this.currentDate) && (compareDate <= this.startDate.value);
    }

    setDesiredTerm(): void {
        if (this.startDate == null || this.startDate.value == null ||
            this.endDate == null || this.endDate.value == null
        ) {
            this.desiredTerm = null;
            this.sellOffer.termPeriod = 0;
            return;
        }
        var diff = this.endDate.value.diff(this.startDate.value, ["months"]);
        var mnth = Math.floor(diff["months"]);
        if (mnth >= 0) {
            this.desiredTerm = mnth + " months";
            this.sellOffer.termPeriod = mnth;
        } else {
            this.desiredTerm = null;
            this.sellOffer.termPeriod = 0;
        }
    }

    setDefaultDuration(cValue: DateTime): void {
        if (cValue == null) {
            return;
        }
        cValue = this.applySitesTimeZone(cValue).minus({ days: 1 });
        if (cValue < this.currentDate) {
            cValue = this.currentDate;
        }
        this.validDate.setValue(cValue);
    }


    cancel(): void {
        this.dialogRef.close(null!);
    }

    boundInactiveDatesFilter = this.inactiveDatesFilter.bind(this);
    boundInactiveDatesEndFilter = this.inactiveDatesEndFilter.bind(this);
    boundInactiveDatesValidFilter = this.inactiveDatesValidFilter.bind(this);

}